module.exports = "<div class=\"modal-header\">\n  <h4 class=\"modal-title\">Edit User Details</h4>\n  <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"close(false)\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n    <ng-content></ng-content>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-primary\" (click)=\"close(true)\">Save</button>\n  <button type=\"button\" class=\"btn btn-secondary\" (click)=\"close(false)\">Cancel</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/editusermodal.component.html
// module id = 613
// module chunks = 1